module.exports = __webpack_public_path__ + "static/media/exe.c6b15676.svg";